import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {runInAction} from "mobx"
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";

export class NewSearchWidgetTabClickHandler extends ActionHandler {
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      const numOfSections: Number = this.state.searchModelsExists ? 3 : 2;
      if (this.state.isSportTypesDropdownActiveNavigation && !(params.index > 0)) {
        this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick, {isOpen: false})
      }

      if (params.index >= 0 && this.state.highlightedSection !== params.index) {
        this.state.highlightedSection = false;
        this.state.activeNavigationSection = params.index
      }

      if (this.state.highlightedSection === -1 && params.direction) {
        this.state.activeNavigationSection = NEW_SEARCH_WIDGET.TAB_SECTION.popularAndResults;
      } else if (params.direction === NEW_SEARCH_WIDGET.DIRECTIONS.next) {
        this.state.highlightedSection = true;
        this.state.activeNavigationSection = (this.state.activeNavigationSection + 1).mod(numOfSections)
      } else if (params.direction === NEW_SEARCH_WIDGET.DIRECTIONS.prev) {
        this.state.highlightedSection = true;
        this.state.activeNavigationSection = (this.state.activeNavigationSection - 1).mod(numOfSections)
      } else if (params.reset) {
        this.state.highlightedSection = false;
        this.state.activeNavigationSection = -1;
        this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick, {isOpen: false})
      }
    })
  }
}
